import { Button, Modal, Text } from '@viapeople/components'
import type React from 'react'

interface ConfirmationDialogProps {
	isOpen: boolean
	onClose: () => void
	onConfirm: () => void
	isSubmitting?: boolean
	title: string
	message: string
	confirmLabel: string
	confirmVariant?: 'primary' | 'secondary' | 'destructive'
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
	isOpen,
	onClose,
	onConfirm,
	isSubmitting = false,
	title,
	message,
	confirmLabel,
	confirmVariant = 'primary',
}) => {
	return (
		<Modal title={title} isOpen={isOpen} onClose={onClose} className='max-w-lg'>
			<div className='p-6'>
				<div className='mb-6'>
					<Text variant='medium' className='text-neutral-600'>
						{message}
					</Text>
				</div>

				<div className='flex gap-3 justify-end'>
					<Button variant='secondary' onClick={onClose} disabled={isSubmitting}>
						Cancel
					</Button>
					<Button variant={confirmVariant} onClick={onConfirm} disabled={isSubmitting}>
						{confirmLabel}
					</Button>
				</div>
			</div>
		</Modal>
	)
}
